import { NavLink } from 'react-router-dom';
import { isBilltoro } from '../../produkt';
import './kontakte.css';

const BILLTORO = isBilltoro();
const chip = ({ isActive }: { isActive: boolean }) => `rt-chip kt-nav-chip${isActive ? ' on' : ''}`;

// Billtoro: Chips „Kunden“ · „Lieferanten“ oben auf beiden Listen (der Reiter heißt dort „Kontakte“), daneben
// „Dateien als ZIP“ (alle Dateien an Kunden und Lieferanten; zip nur mit dem Recht „Exporte“). In der Kanzlei-App gibt
// es keine Lieferanten: nichts.
export function KontakteNav({ zip }: { zip?: string }) {
  if (!BILLTORO) return null;
  return (
    <div className="kt-nav-zeile">
      <nav className="rt-chips kt-nav" aria-label="Kontakte">
        <NavLink to="/rechnung/kunden" className={chip}>
          Kunden
        </NavLink>
        <NavLink to="/rechnung/lieferanten" className={chip}>
          Lieferanten
        </NavLink>
      </nav>
      {zip && (
        <a className="linkbtn kt-zip" href={zip} download>
          Dateien als ZIP
        </a>
      )}
    </div>
  );
}
